import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=6c6a402c&name=component-name&"
import script from "./InputComponent.vue?vue&type=script&lang=js&"
export * from "./InputComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports